import React, { useEffect, useState, Fragment } from 'react';
import { motion } from 'framer-motion';
import { Clock, Book, Trophy, Star, ArrowRight, Lock, Zap, ShieldCheck, CreditCard } from 'lucide-react';
import { Button } from './Button';
export function Pricing() {
  const [selectedPack, setSelectedPack] = useState<'basic' | 'complete'>('complete');
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 50
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (value: number) => value.toString().padStart(2, '0');
  return <section className="py-20 bg-nutri-black text-white relative" data-id="element-191">
      <div className="container mx-auto px-4 max-w-2xl" data-id="element-192">
        {/* Timer Section */}
        <div className="flex flex-col items-center mb-10" data-id="element-193">
          <div className="flex items-center gap-2 text-nutri-cta font-bold text-sm tracking-wider mb-4" data-id="element-194">
            <Clock size={16} data-id="element-195" />
            ESTA OFERTA TERMINA EN
          </div>

          <div className="flex items-center gap-4 text-center" data-id="element-196">
            {[{
            value: timeLeft.hours,
            label: 'HORAS'
          }, {
            value: timeLeft.minutes,
            label: 'MIN'
          }, {
            value: timeLeft.seconds,
            label: 'SEGUNDOS'
          }].map((unit, i) => <Fragment key={unit.label} data-id="element-197">
                {i > 0 && <div className="text-nutri-cta text-3xl md:text-4xl font-bold -mt-6" data-id="element-198">
                    :
                  </div>}
                <div className="flex flex-col items-center" data-id="element-199">
                  <div className="bg-[#112218] border border-white/5 rounded-xl w-16 h-16 md:w-20 md:h-20 flex items-center justify-center text-3xl md:text-4xl font-bold shadow-inner" data-id="element-200">
                    {formatTime(unit.value)}
                  </div>
                  <span className="text-xs text-gray-400 mt-2 font-bold tracking-widest" data-id="element-201">
                    {unit.label}
                  </span>
                </div>
              </Fragment>)}
          </div>
        </div>

        {/* Title */}
        <div className="text-center mb-8" data-id="element-202">
          <h2 className="text-3xl md:text-4xl font-extrabold mb-3" data-id="element-203">
            ELEGÍ TU <span className="text-nutri-cta" data-id="element-204">PACK PROFESIONAL</span>
          </h2>
          <p className="text-gray-300 text-lg" data-id="element-205">
            Ambas opciones incluyen los 6 bonos estratégicos completos
          </p>
        </div>

        {/* Cards */}
        <div className="space-y-4 mb-8" data-id="element-206">
          {/* Basic Pack Card */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} onClick={() => setSelectedPack('basic')} className={`cursor-pointer rounded-2xl p-5 md:p-6 border-2 transition-all duration-200 flex items-start md:items-center gap-4 ${selectedPack === 'basic' ? 'border-nutri-cta bg-[#112218]' : 'border-white/10 bg-white/5 hover:bg-white/10'}`} data-id="element-207">
            <div className={`mt-1 md:mt-0 w-6 h-6 rounded-full border-2 flex-shrink-0 flex items-center justify-center ${selectedPack === 'basic' ? 'border-nutri-cta' : 'border-gray-500'}`} data-id="element-208">
              {selectedPack === 'basic' && <div className="w-3 h-3 bg-nutri-cta rounded-full" data-id="element-209" />}
            </div>

            <div className="flex-grow" data-id="element-210">
              <div className="flex items-center gap-2 mb-1" data-id="element-211">
                <Book size={20} className={selectedPack === 'basic' ? 'text-white' : 'text-gray-400'} data-id="element-212" />
                <h3 className="font-bold text-lg md:text-xl" data-id="element-213">NUTRIPRO KIT</h3>
              </div>
              <p className="text-gray-400 text-sm md:text-base" data-id="element-214">
                6 tomos + 6 bonos
              </p>
            </div>

            <div className="text-right flex-shrink-0" data-id="element-215">
              <div className="text-gray-500 line-through text-sm md:text-base mb-0.5" data-id="element-216">
                $34.990
              </div>
              <div className="text-2xl md:text-3xl font-extrabold" data-id="element-217">$19.990</div>
            </div>
          </motion.div>

          {/* Complete Pack Card */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} onClick={() => setSelectedPack('complete')} className={`cursor-pointer rounded-2xl p-5 md:p-6 border-2 transition-all duration-200 flex items-start md:items-center gap-4 ${selectedPack === 'complete' ? 'border-nutri-cta bg-[#112218] shadow-[0_0_30px_rgba(34,197,94,0.15)]' : 'border-white/10 bg-white/5 hover:bg-white/10'}`} data-id="element-218">
            <div className={`mt-1 md:mt-0 w-6 h-6 rounded-full border-2 flex-shrink-0 flex items-center justify-center ${selectedPack === 'complete' ? 'border-nutri-cta' : 'border-gray-500'}`} data-id="element-219">
              {selectedPack === 'complete' && <div className="w-3 h-3 bg-nutri-cta rounded-full" data-id="element-220" />}
            </div>

            <div className="flex-grow" data-id="element-221">
              <div className="flex items-center gap-2 mb-2" data-id="element-222">
                <Trophy size={20} className={selectedPack === 'complete' ? 'text-white' : 'text-gray-400'} data-id="element-223" />
                <h3 className="font-bold text-lg md:text-xl" data-id="element-224">PACK COMPLETO</h3>
              </div>

              <div className="flex flex-wrap gap-2 mb-2" data-id="element-225">
                <span className="bg-yellow-500 text-nutri-black text-xs font-bold px-2 py-0.5 rounded flex items-center gap-1" data-id="element-226">
                  <Star size={10} fill="currentColor" data-id="element-227" /> MÁS ELEGIDO
                </span>
                <span className="bg-nutri-medium/30 text-nutri-cta border border-nutri-cta/30 text-xs font-bold px-2 py-0.5 rounded" data-id="element-228">
                  AHORRÁS $16.000
                </span>
              </div>

              <p className="text-gray-400 text-sm md:text-base" data-id="element-229">
                6 tomos + 6 bonos + planillas premium
              </p>
            </div>

            <div className="text-right flex-shrink-0 self-center" data-id="element-230">
              <div className="text-gray-500 line-through text-sm md:text-base mb-0.5" data-id="element-231">
                $43.990
              </div>
              <div className="text-2xl md:text-3xl font-extrabold text-nutri-cta" data-id="element-232">
                $27.990
              </div>
            </div>
          </motion.div>
        </div>

        {/* CTA Button */}
        <Button onClick={() => {
        const url = selectedPack === 'complete' ? 'https://checkout.tusbeneficios.shop/cart/51267605758185:1' : 'https://checkout.tusbeneficios.shop/cart/51267605659881:1';
        window.location.href = url;
      }} className="w-full py-5 text-lg md:text-xl flex items-center justify-center gap-2 mb-6 shadow-[0_0_20px_rgba(34,197,94,0.4)]" data-id="element-233">
          {selectedPack === 'complete' ? 'SÍ, QUIERO EL PACK COMPLETO' : 'SÍ, QUIERO EL NUTRIPRO KIT'}
          <ArrowRight size={24} data-id="element-234" />
        </Button>

        <p className="text-center text-gray-400 italic text-sm mb-8" data-id="element-235">
          La opción más elegida por quienes buscan resultados reales en su
          consultorio.
        </p>

        <hr className="border-white/10 mb-8" data-id="element-236" />

        {/* Trust & Payment */}
        <div className="flex flex-col items-center gap-6" data-id="element-237">
          <div className="flex flex-wrap justify-center gap-4 md:gap-8 text-sm text-gray-300" data-id="element-238">
            <div className="flex items-center gap-2" data-id="element-239">
              <Lock size={16} className="text-nutri-cta" data-id="element-240" />
              <span data-id="element-241">Pago seguro</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-242">
              <Zap size={16} className="text-nutri-cta" data-id="element-243" />
              <span data-id="element-244">Acceso inmediato</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-245">
              <ShieldCheck size={16} className="text-nutri-cta" data-id="element-246" />
              <span data-id="element-247">Garantía 30 días</span>
            </div>
          </div>

          <div className="flex items-center gap-2 text-sm text-gray-400" data-id="element-248">
            <CreditCard size={18} className="text-nutri-cta" data-id="element-249" />
            <span data-id="element-250">Mercado Pago</span>
          </div>
        </div>
      </div>
    </section>;
}